import CircularProgress from '@material-ui/core/CircularProgress';

import styles from './LoadingArea.style';

class LoadingArea extends React.Component {
  renderLoading() {
    const { classes } = this.props;

    return (
      <div className={classes.loading}>
        <CircularProgress />
      </div>
    );
  }

  renderEmpty() {
    const { emptyBody, classes } = this.props;

    return <div className={classes.empty}>{emptyBody}</div>;
  }

  renderChildren() {
    const { classes, children } = this.props;

    return <div className={classes.children}>{children}</div>;
  }

  renderInner() {
    const { loading, empty } = this.props;

    if (loading) {
      return this.renderLoading();
    } else if (empty) {
      return this.renderEmpty();
    } else {
      return this.renderChildren();
    }
  }

  render() {
    const { classes, style, className } = this.props;

    return (
      <div className={classnames(classes.root, className)} style={style}>
        {this.renderInner()}
      </div>
    );
  }
}

LoadingArea.defaultProps = {
  emptyBody: 'Nothing to show',
  empty: false,
  loading: false,
  style: {},
};

export default withStyles(styles)(LoadingArea);
